<template>
  <PageShell class="page-shell-wrapper--legal" locale="id" :page-title="pageTitle">
    <LegalContent slug="dmca" />
  </PageShell>
</template>

<script>
import PageShell from '@/components/layout/PageShell.vue';
import LegalContent from './LegalContent.vue';

export default {
  name: 'DmcaPage',
  components: { PageShell, LegalContent },
  computed: {
    pageTitle() {
      return this.$route.meta.pageTitle || '';
    },
  },
};
</script>
